// SidebarWrapper.js

import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import SidebarMenu from './SidebarMenu';

const SidebarWrapper = () => {
  const { currentUser, isLoading } = useAuth();

  if (isLoading) {
    // If still loading, don't show anything (or show a loader)
    return null;
  }

  if (!currentUser?.accessToken) {
    // If not logged in, don't show the sidebar
    // and allow the main content to use the full width of the screen
    return <div style={{ width: '65px' }} />; // Empty div to maintain the space for the sidebar
  }

  // If logged in, show the sidebar
  return <SidebarMenu />;
};

export default SidebarWrapper;
